function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

export function toHashMapString(obj) {
  if (!obj) return;
  Object.keys(obj).forEach(function (k) {
    if (_typeof(obj[k]) === "object") {
      obj[k] = JSON.stringify(obj[k]);
    }

    obj[k] = String(obj[k]);
  });
  return obj;
}
export function toHashMap(obj) {
  if (!obj) return;
  Object.keys(obj).forEach(function (k) {
    if (typeof obj[k] === "string" || typeof obj[k] === "boolean" || typeof obj[k] === "number") {
      return;
    }

    obj[k] = JSON.stringify(obj[k]);
  });
  return obj;
}